import { render } from "./PuntoPickCentro.vue?vue&type=template&id=77527997"
import script from "./PuntoPickCentro.vue?vue&type=script&lang=ts"
export * from "./PuntoPickCentro.vue?vue&type=script&lang=ts"
script.render = render

export default script